import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, Heart, ShieldCheck, Brain } from "lucide-react";

export default function Landing() {
  return (
    <div className="app-shell bg-aurora min-h-screen relative overflow-hidden" data-testid="landing-page">
      {/* Decorative blobs */}
      <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full bg-[#5F7F77]/15 blur-3xl pointer-events-none" />
      <div className="absolute top-1/3 -left-24 w-72 h-72 rounded-full bg-[#C9A66B]/12 blur-3xl pointer-events-none" />

      <div className="relative px-7 pt-16 pb-10 flex flex-col min-h-screen">
        {/* Logo */}
        <div className="flex items-center gap-2 mb-12">
          <div className="w-10 h-10 rounded-2xl bg-gradient-to-br from-[#082A24] to-[#0F3D34] flex items-center justify-center shadow-lg">
            <Heart size={20} fill="white" strokeWidth={0} className="text-white" />
          </div>
          <span className="font-display text-2xl font-semibold text-[#332D38]">Sentra</span>
        </div>

        {/* Hero */}
        <div className="flex-1 flex flex-col justify-center">
          <h1 className="font-display text-5xl leading-[1.05] text-[#332D38] mb-4">
            Najdi někoho,<br />
            <span className="italic text-[#C9A66B]">kdo se k tobě</span><br />
            opravdu hodí.
          </h1>
          <p className="text-[#54635F] text-lg leading-relaxed mb-10 max-w-sm">
            AI, která ti pomůže pochopit vztahy — od první zprávy po skutečnou kompatibilitu. ❤️
          </p>

          {/* Feature pills */}
          <div className="space-y-3 mb-12">
            <FeaturePill icon={<Brain size={18} strokeWidth={1.7} />} text="AI kompatibilita podle hodnot, cílů a očekávání" />
            <FeaturePill icon={<Sparkles size={18} strokeWidth={1.7} />} text="Návrhy první zprávy, které sednou" />
            <FeaturePill icon={<ShieldCheck size={18} strokeWidth={1.7} />} text="Bezpečí, soukromí, žádné swipování naslepo" />
          </div>
        </div>

        {/* CTA */}
        <div className="space-y-3">
          <Link to="/register" data-testid="cta-register">
            <button className="btn-primary">Vytvořit účet</button>
          </Link>
          <Link to="/login" data-testid="cta-login">
            <button className="btn-secondary">Už mám účet</button>
          </Link>
          <p className="text-center text-xs text-[#8A7E91] mt-4">
            Sentra AI ❤️ — jednorázový nákup v App Store, žádné skryté poplatky
          </p>
        </div>
      </div>
    </div>
  );
}

function FeaturePill({ icon, text }) {
  return (
    <div className="flex items-center gap-3 glass-card px-4 py-3">
      <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#082A24] to-[#0F3D34] text-white flex items-center justify-center shrink-0">{icon}</div>
      <p className="text-sm text-[#332D38] leading-snug">{text}</p>
    </div>
  );
}
